import React from "react";
import TrustedBy from "../../components/trusted-by";
import MapToSafety from "../../components/map-to-safety";
import BlogSection from "../../components/blog-section";
import HomeHero from "../../components/home-hero";
import SecurityAuditSection from "../../components/security-audit-section";
import AuditHighlights from "../../components/audit-highlights";
import FAQSection from "../../components/faq-section";
import RecentEvents from "../../components/recent-events";
import RwaDefiSection from "../../components/rwa-defi-section";

import Meta from '../../components/SEO/Meta';

const Homepage = () => {
  const canonicalUrl = "https://safeedges.in/";

  return (
    <>
      {/* React 19 native document metadata. react-helmet 6.1.0 declares peer React ^16
          and mutates document.head directly; with five instances mounted on this page it
          raced React 19's commit and threw "insertBefore ... not a child of this node". */}
      <Meta
        title="Smart Contract Audit Firm | 200+ Audits, $4B Secured — Safe Edges"
        description="Safe Edges has audited 200+ protocols and secured $4B+ in digital assets with 0 hacks. Official Fuel Chain security partner. Smart contract, DeFi & Web3 audits. Get a free consultation."
        canonical={canonicalUrl}
        schemas={[
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [{ '@type': 'ListItem', position: 1, name: 'Home', item: 'https://safeedges.in/' }],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'ProfessionalService',
            name: 'Safe Edges',
            description: 'Smart contract audit firm. 200+ protocols audited, $4B+ secured, 0 hacks. Official Fuel Chain security partner.',
            url: 'https://safeedges.in',
            logo: 'https://safeedges.in/logo.png',
            image: 'https://safeedges.in/og-image.png',
            email: 'info@safeedges.in',
            address: { '@type': 'PostalAddress', addressCountry: 'IN' },
            priceRange: '$$',
            areaServed: { '@type': 'Place', name: 'Worldwide' },
            sameAs: [
              'https://twitter.com/SafeEdges',
              'https://www.linkedin.com/company/safe-edges',
              'https://safe-edges.medium.com/',
              'https://github.com/Safe-Edges',
            ],
          },
        ]}
      />
      
      <div className="bg-black text-white overflow-x-hidden">
        {/* 1. Hero — brand + CTA */}
        <HomeHero />

        {/* 2. RWA, stablecoins, tokenized securities, tokenization, DeFi */}
        <RwaDefiSection />

        {/* 3. Social proof */}
        <MapToSafety />


        {/* 4. Products (Bastion, SwayScan, EVM Sleuth) */}
        <SecurityAuditSection />

        {/* 5. Logos */}
        <TrustedBy />

        {/* 6. Audit reports */}
        <AuditHighlights />

        {/* 7. Insights */}
        <BlogSection />

        {/* 8. Where the team has been in person */}
        <RecentEvents />

        {/* 9. FAQ */}
        <FAQSection />
      </div>
    </>
  );
};

export default Homepage;
